module.exports = "/_next/static/images/GettingStarted2-8c9b58dd824154ffdc002aefc4df94fa.png";